/* lua.js generated code undefined */

/*     正交分组

    关于正交分组的设计及算法，详见文档：https://docs.google.com/document/d/1KSFwQJ8X081Q9xC6mXJ2jJf22zN3BTWSfzaZlgZUY5Q/edit#
    开发文档：https://docs.google.com/document/d/1bF9dIpbJq-4qA7MtIZImVtEb3_KhXJS_uIvW7hWNFb4/edit

    author: 张力 jay.zhang
    time: 2020-09-01 18:33:18
 */
let md5 = require("clover/utils/md5")
const Event = require("cocos/framework/components/event")
OrthGroupHelper = xClass("OrthGroupHelper", Event)
let _instance = null
OrthGroupHelper.getInstance = function () {
    let self = this
    if (!_instance) {
        _instance = OrthGroupHelper.new()
    }
    return _instance
}
OrthGroupHelper.prototype.ctor = function () {
    let self = this
    // 正交分组配置
    self.orthGroupMeta = UserTagData.getInstance().orthgroupConfig;

    // 测试用强制取模
    _weightMod = null;
}
/*     @desc: 查询是否能进行测试
    --@testId: 正交分组表(test_group)中的测试id
    @return: 是否能进行测试
 */
OrthGroupHelper.prototype.getEnableTest = function (testId) {
    let self = this
    testId = tonumber(testId)
    let item = self.orthGroupMeta[tonumber(testId)]
    if (item) {
        let str = "----------------- 查询test_group【" + testId + "】-----------------" + "\n"
        + "当前时间：" + JSON.stringify(os.date("%Y-%m-%d %H:%M:%S", Localhost.timeInSec())) + "\n";
        + "当前配置信息：" + "\n";
        + "id: " + item.metaId + "\n";
        + "testName: " + item.testName + "\n";
        + "switch: " + tostring(item.switch) + "\n";
        + "startTime: " + JSON.stringify(os.date("%Y-%m-%d %H:%M:%S", item.startTime)) + "\n";
        + "endTime: " + JSON.stringify(os.date("%Y-%m-%d %H:%M:%S", item.endTime)) + "\n";
        + "testGroup: " + item.testGroup + "\n";
        console.log(str);
        // QAGUILogger.getInstance().print("----------------- 查询test_group【" + testId + "】-----------------", "orth")
        // QAGUILogger.getInstance().print("当前时间：" + JSON.stringify(os.date("%Y-%m-%d %H:%M:%S", Localhost.timeInSec())), "orth")
        // QAGUILogger.getInstance().print("当前配置信息：", "orth")
        // QAGUILogger.getInstance().print("id: " + item.metaId, "orth")
        // QAGUILogger.getInstance().print("testName: " + item.testName, "orth")
        // QAGUILogger.getInstance().print("switch: " + tostring(item.switch), "orth")
        // QAGUILogger.getInstance().print("startTime: " + JSON.stringify(os.date("%Y-%m-%d %H:%M:%S", item.startTime)), "orth")
        // QAGUILogger.getInstance().print("endTime: " + JSON.stringify(os.date("%Y-%m-%d %H:%M:%S", item.endTime)), "orth")
        // QAGUILogger.getInstance().print("testGroup: " + item.testGroup, "orth")
    } else {
        return false
    }
    item = self.getTestGroupItem(testId)
    let result = true
    if (!item.switch) {
        console.log("开关关闭");
        // QAGUILogger.getInstance().print("开关关闭", "orth")
        result = false
    } else {
        // 检查时间是否有效
        let now = Localhost.timeInSec()
        if (now < item.startTime || now > item.endTime) {
            console.log("时间不符合");
            // QAGUILogger.getInstance().print("时间不符合", "orth")
            result = false
        } else {
            let myGroupInfo = item.testGroup[item.myGroupIndex - 1]
            if (myGroupInfo) {
                console.log("\n玩家所在组: " + myGroupInfo.group + "\n");
                // QAGUILogger.getInstance().print("\n玩家所在组: " + myGroupInfo.group + "\n", "orth")
            } else {
                console.log("\n玩家所在组: " + item.myGroupIndex + " 错误：没有组信息！" + "\n");
                // QAGUILogger.getInstance().print("\n玩家所在组: " + item.myGroupIndex + " 错误：没有组信息！" + "\n", "orth")
            }
            // 检查标签是否满足
            let checkTag = self._checkStrategy(myGroupInfo.strategyStr)
            if (!checkTag) {
                console.log("条件未满足");
                // QAGUILogger.getInstance().print("条件未满足", "orth")
                result = false
            }
        }
    }
    console.log("\n结束查询test_group【" + testId + "】最终结果: " + tostring(result));
    console.log("---------------------------------------------------------------")
    // QAGUILogger.getInstance().print("\n结束查询test_group【" + testId + "】最终结果: " + tostring(result), "orth")
    // QAGUILogger.getInstance().print("---------------------------------------------------------------", "orth")
    return result
}
/*     @desc: 获取测试所在分组
    --@testId: 正交分组表(test_group)中的测试id
    @return: 测试分组编号
 */
OrthGroupHelper.prototype.getTestGroupIndex = function (testId) {
    let self = this
    let item = self.getTestGroupItem(testId)
    if (item) {
        return item.myGroupIndex
    }
    return 0
}
/*     @desc: 获取分组信息
    --@testId: 正交分组表(test_group)中的测试id
    @return: 测试分组信息（包含了计算玩家所在分组item.myGroupIndex）
 */
OrthGroupHelper.prototype.getTestGroupItem = function (testId) {
    let self = this
    let item = self.orthGroupMeta[tonumber(testId)]
    if (!item) {
        return null
    }
    // if (!item.myGroupIndex) {
        self._calcGroupIndex(testId)
    // }
    // 强制覆盖指定分组
    if (OrthGroupHelper.getInstance()._testGroupId) {
        item.myGroupIndex = OrthGroupHelper.getInstance()._testGroupId
        console.log("强制指定分组：G" + item.myGroupIndex);
        // QAGUILogger.getInstance().print("强制指定分组：G" + item.myGroupIndex, "orth")
    }
    return item
}
/*     @desc: 用户登录游戏时打点(每条一个test_id，如果同时存在多个不同test_id的测试、则需要同时上报多条）
 */
OrthGroupHelper.prototype.dcOrthGroupAfterLogin = function () {
    let self = this
    let now = Localhost.timeInSec()
    for (let k in self.orthGroupMeta) {
        let item = self.orthGroupMeta[k]
        if ($null(item)) continue
        if (item.switch && now > item.startTime && now < item.endTime) {
            let v = self.getTestGroupItem(item.metaId)
            let result = self.getEnableTest(item.metaId)
            DCAssist.dc4OrthGroup(item.metaId, item.testName, v.myGroupIndex, result)
        }
    }
}
/*     @desc: 计算所在分组
    --@testId: 正交分组表(test_group)中的测试id
    @return: 玩家所在分组
 */
OrthGroupHelper.prototype._calcGroupIndex = function (testId) {
    let self = this
    let item = self.orthGroupMeta[testId]
    if (!item) {
        return 
    }
    item.weights = table()
    for (let i = 0; i < item.testGroup.length; i++) {
        table.insert(item.weights, item.testGroup[i].weight)
    }
    let str = "\n-----计算分组【开始】" + "\n";
    // QAGUILogger.getInstance().print("\n-----计算分组【开始】", "orth")
    console.log("testGroup", item.testGroupStr);
    let version = md5(item.testGroupStr)
    str += "1. 计算testGroup字段的MD5值：" + version + "\n";
    // QAGUILogger.getInstance().print("1. 计算testGroup字段的MD5值：" + version, "orth")
    let connectStr = item.testName + version + UserManager.getInstance().uid
    str += "2. 拼接 testName + version + gid：" + connectStr + "\n";
    // QAGUILogger.getInstance().print("2. 拼接 testName + version + gid：" + connectStr, "orth")
    let connectStrMd5 = md5(connectStr)
    str += "3. 再次计算MD5：" + connectStrMd5 + "\n";
    // QAGUILogger.getInstance().print("3. 再次计算MD5：" + connectStrMd5, "orth")
    let subhex = string.sub(connectStrMd5, $len(connectStrMd5) - 8 + 1)
    str += "4. 取最后8位：" + subhex + "\n";
    // QAGUILogger.getInstance().print("4. 取最后8位：" + subhex, "orth")
    let num = tonumber(subhex, 16)
    str += "5. 转为十进制：" + num + "\n";
    // QAGUILogger.getInstance().print("5. 转为十进制：" + num, "orth")
    let totalWeights = 0
    for (let i = 1, v = item.weights[1]; v; i++, v = item.weights[i]) {
        totalWeights = totalWeights + v
    }
    str += "6. 计算所有权重之和：" + totalWeights + "\n";
    // QAGUILogger.getInstance().print("6. 计算所有权重之和：" + totalWeights, "orth")
    let mod = Math.mod(num, totalWeights);
    if (OrthGroupHelper.getInstance()._weightMod != null) {
        mod = OrthGroupHelper.getInstance()._weightMod;
        console.log("强制指定取模" + _weightMod);
        // QAGUILogger.getInstance().print("强制使用【levelAreaRealTime】" + topLevel, "orth")
    }
    str += "7. 对权重和取模：" + mod + "\n";
    // QAGUILogger.getInstance().print("7. 对权重和取模：" + mod, "orth")
    let groupIndex = 1
    totalWeights = 0
    for (let i = 1, v = item.weights[1]; v; i++, v = item.weights[i]) {
        totalWeights = totalWeights + v
        if (mod < totalWeights) {
            groupIndex = i
            break
        }
    }
    item.myGroupIndex = groupIndex
    str += "8. 计算所在分组：" + item.testGroup[groupIndex - 1].group + "\n";
    // QAGUILogger.getInstance().print("8. 计算所在分组：G" + groupIndex, "orth")
    str += "-----计算分组【结束】\n" + "\n";
    // QAGUILogger.getInstance().print("-----计算分组【结束】\n", "orth")
    console.log(str);
}
/*     @desc: 检查策略是否满足（标签是否满足）
    --@strategyStr: 这是一个表达式，例如：12|(9&(10|11))，其中数字是test_detail表中的id，需满足每个id对应的tag条件
    @return: 是否满足(true/false)
 */
OrthGroupHelper.prototype._checkStrategy = function (strategyStr) {
    let self = this
    if (strategyStr === "") {
        return true
    }
    let result = false
    let callStr = "OrthStrategyHelper:getInstance():checkStrategy"
    let expressionStr = string.trim(strategyStr)
    expressionStr = string.gsub(expressionStr, "&", " and ")
    expressionStr = string.gsub(expressionStr, "|", " or ")
    expressionStr = string.gsub(expressionStr, "%d+", callStr + "(%1)")
    expressionStr = "return " + expressionStr
    // let f = loadstring(expressionStr)
    let f = OrthStrategyHelper.getInstance().checkStrategy(strategyStr)
    if (f) {
        result = f
        // result = f()
    } else {
        console.log("表达式错误：" + strategyStr)
        // QAGUILogger.getInstance().print("表达式错误：" + strategyStr, "orth")
    }
    return result
    // let orthMetaIds = UserTagData.getInstance().orthMetaIds;
    // for (const k in orthMetaIds) {
    //     if (strategyStr == orthMetaIds[k]){
    //         return true;
    //     }
    // }
    // return false;
}
